import { render, staticRenderFns } from "./BrotherOne.vue?vue&type=template&id=da2ca86a&scoped=true"
import script from "./BrotherOne.vue?vue&type=script&lang=js"
export * from "./BrotherOne.vue?vue&type=script&lang=js"
import style0 from "./BrotherOne.vue?vue&type=style&index=0&id=da2ca86a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2ca86a",
  null
  
)

export default component.exports